import home from "../home"
import dashboard from "../items/dashboard"
import index from "../items/index"
export default {
	path:'/home',
	name:'home',
	component:home,
	children:[
		{
			path:'dashboard',
			name:'dashboard',
			component:dashboard
		},
		{
			path:'index',
			name:'index',
			component:index
		},
	]
}